var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-content',[_c('div',{staticClass:"z-card border-0"},[_c('user-info',{staticClass:"w-50"}),_c('change-password',{staticClass:"mt-4"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }